// The site's bot. While the rules and teams are changing, the planner (ai.ts) plays every game: it
// handles any team without training. The win-chance bot (bot/wc/) beat it with the old standard team
// (63% over 30 pairs) but its weights were fitted to that team: with the other built-in teams it lost
// (18–33%), and with the new Three squires (Bulwark Move 4, Lancer 7) it scored 40% ± 12% over 30 pairs
// (2026-10-13). It comes back after the retrain on mixed setups (self-play run g1; TODO.md).

import { getPlannerBotAction } from './ai';
import type { CtfAction, CtfPlayer, CtfState } from './types';

export function getBotAction(player: CtfPlayer, s: CtfState): CtfAction | null {
  return getPlannerBotAction(player, s);
}
